'use strict';

import jsonp from 'jsonp-promise';
import query from 'query-string';
import WebinarActions from '../actions/webinar.actions';

let base = pensions_api_url + '/v1/events';
let key = '7803c9c9f39e6d58a831a8f10df0d1394a94e38d';
let limit = 500;
let status = 'disabled'; // Show webinars NOT equal to disabled

let maxDate  = new Date();
maxDate.setHours(0,0,0,0);

const WebinarsSource = {
    fetch: {
        remote(state, props) {
            return jsonp([base, query.stringify({
                key: key,
                fields: props.fields,
                limit: limit,
                order: (props.date_order ? props.date_order : 'date:ASC'),
                event_type: props.type,
                'status:neq': status,
                'expiration:gte': maxDate.valueOf() / 1000
            })].join('?')).promise;
        },
        shouldFetch(state) {
            return true;
        },
        success: WebinarActions.loadedAll
    }
};

export default WebinarsSource;
